import { render } from "./theme-toggler-v3.vue?vue&type=template&id=54b30a11&scoped=true"
import script from "./theme-toggler-v3.vue?vue&type=script&lang=js"
export * from "./theme-toggler-v3.vue?vue&type=script&lang=js"

import "./theme-toggler-v3.vue?vue&type=style&index=0&id=54b30a11&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b30a11"]])

export default __exports__